import * as React from 'react';
import * as classes from './text-bubble.scss';

export const TextBubble = (props: { text: string }) => (
  <div className={classes.bubble}>
    <div className="row middle-xs center-xs">
      <p className={classes.text}>{props.text}</p>
    </div>
    <div className={classes.triangle} />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/emoji/_components/text-bubble/text-bubble.tsx